import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {Router} from '@angular/router';
import {Utils} from '../../classes/utils';
import { CustomCard2Component } from './custom-card2/custom-card2.component';
import { WsService } from '../../services/ws.service';
import { ADMINISTRATION_VOICES, ADMIN_VOICES, PRODUZIONE_VOICES, VENDITORE_VOICES } from '../../common/constants';

@Component({
    selector: 'app-menu-left',
    templateUrl: './menu-left.component.html',
    styleUrls: ['./menu-left.component.scss'],
    standalone: false
})
export class MenuLeftComponent implements OnInit {

  @ViewChildren('childs') items: QueryList<CustomCard2Component>;

  public voices : string[] = [];
  public icons : string[] = [];
  public sub : string [][];
  public routerLinks : string[] = [];
  public currentSelected;
  public myRole: string;

  constructor(
    private router : Router,
		public utils : Utils,
    private wsService: WsService) {

			this.voices = this.utils.myVoices;
			this.icons = this.utils.myIcons;
  }

  updateVoice(updatedVoices: string[]) {
    this.voices = updatedVoices;
	this.icons = this.voices.map(v => {
		const index = this.utils.myVoices.indexOf(v);
		return this.utils.myIcons[index];
	});
  }

  ngOnInit(): void {
    this.myRole = this.utils.getHighestRole();

    if (this.myRole == "ADMIN") {
			this.wsService.adminVoices$
            .subscribe((updatedVoices: string[]) => {
				console.log("VOICES aggiornate nel menu:", updatedVoices);
				this.voices = updatedVoices;
				this.icons = this.voices.map(v => {
					const index = this.utils.myVoices.indexOf(v);
					return this.utils.myIcons[index];
				  });
			});
		} else if (this.myRole == "AMMINISTRAZIONE") {
			this.wsService.administratorVoices$
            .subscribe((updatedVoices: string[]) => {
				this.voices = updatedVoices;
				this.icons = this.voices.map(v => {
					const index = this.utils.myVoices.indexOf(v);
					return this.utils.myIcons[index];
				  });
			});
		} else if (this.myRole == "VENDITORE-EI" || this.myRole == "VENDITORE") {
			this.wsService.venditoreVoices$
            .subscribe((updatedVoices: string[]) => {
				this.voices = updatedVoices;
				this.icons = this.voices.map(v => {
					const index = this.utils.myVoices.indexOf(v);
					return this.utils.myIcons[index];
				  });
			});
		} else if (this.myRole == "PRODUZIONE") {
			this.wsService.produzioneVoices$
            .subscribe((updatedVoices: string[]) => {
				this.voices = updatedVoices;
				this.icons = this.voices.map(v => {
					const index = this.utils.myVoices.indexOf(v);
					return this.utils.myIcons[index];
				  });
			});
		}

    this.utils.leftClickSubject.subscribe(i => {
        this.currentSelected = i;

        this.items.toArray().forEach(element => {
			element.currentSelected = i
		});
    });

    this.currentSelected = this.retrieveSelected();

    this.wsService.checkButtonsStatus()
        .subscribe(res => {
            let filteredVoices = this.wsService.getVoiceByRole(this.myRole);

            if (res.mode === 'OFF') {
                this.myRole = this.utils.getHighestRole();
                filteredVoices = this.wsService.getFilteredVoiceByRole(this.myRole);
            }

            this.updateVoice(filteredVoices);
        });

  }

  selected(i : any) : void {

	if(typeof i !== "number") return;

    this.currentSelected = i;

    this.items.toArray().forEach(element => {
			element.currentSelected = i as number
		});

    const path = this.retrievePath(this.voices[i]);
    this.router.navigateByUrl(path);
  }

  retrieveSelected(){
    const url = this.router.url;

		if(url.includes("gamma")){
			for (let i = 0; i < this.voices.length; i++){
				let lower = this.voices[i].toLowerCase();
				if(lower.includes("gamma")) return i;
			}
		}

		if(url.includes("preventivi x")){
			for (let i = 0; i < this.voices.length; i++){
				let lower = this.voices[i].toLowerCase();
				if(lower.includes("preventivi x")) return i;
			}
		}

		if(url.includes("generali")){
			for (let i = 0; i < this.voices.length; i++){
				let lower = this.voices[i].toLowerCase();
				if(lower.includes("generali")) return i;
			}
		}

		if(url.includes("cambio%20prezzi") || url.includes("cambio prezzi")){
			for (let i = 0; i < this.voices.length; i++){
				let lower = this.voices[i].toLowerCase();
				if(lower.includes("cambio prezzi")) return i;
			}
		}

    for (let i = 0; i < this.voices.length; i++){
      let lower = this.voices[i].toLowerCase();
      if(url.includes(lower))
        return i;
    }
  }

  retrievePath(link : string) : string {
    var lowerCase : string = link.toLowerCase();
    return "/dashboard/" + lowerCase;
  }

}
